<template>
  <div class="fragment">


    <div v-for="(stickerItem, index) in FBM.data.Stickers" :key="index">
      <div class="order-create__title-horizontal"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <TitleHorizontal
            :value="' #' + (parseInt(index) + 1)"
            :rightBtn="true"
            :rightBtnType="'delete'"
            :rightBtnText="$t('common_delete.localization_value.value')"
            @rightBtnClick="FBM.removeSticker(parseInt(index))"
        />
      </div>

      <StickerItem
          :FBM="FBM"
          :stickerItem="stickerItem"
          :stickerCount="FBM.data.Stickers.length"
          :index="index"
          @changeQuantity="(customization, val) => $emit('changeQuantity', customization, val)"
      />

    </div>

    <div class="custom-row">
      <div class="custom-col mb-0">
        <div class="order-create__product-btn add-product-btn-wrap mb-2">
          <div class="order-create__product-btn-i add-product-btn site-link"
               @click="FBM.addSticker()"
          >
            <div class="admin-edit" @click="editTranslate(['common_AddNew'])"></div>
            +  {{$t('common_AddNew.localization_value.value')}} {{$t('calculatorEngraving_Sticker.localization_value.value')}}
          </div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import TitleHorizontal from "@/components/coreComponents/TitleHorizontal/TitleHorizontal";
import StickerItem
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/StickerItem/StickerItem";

export default {
  name: "Sticker",
  components: {StickerItem, TitleHorizontal},

  props: {
    FBM: Object,
  },



}
</script>

<style scoped>

</style>